import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-79f367df"), n = n(), _popScopeId(), n);
const _hoisted_1 = ["aria-label"];
const _hoisted_2 = {
  key: 0,
  class: "arrow-row arrow-row-top"
};
const _hoisted_3 = ["disabled", "aria-label", "onClick"];
const _hoisted_4 = {
  class: "board-middle"
};
const _hoisted_5 = {
  key: 0,
  class: "arrow-column arrow-column-left"
};
const _hoisted_6 = ["disabled", "aria-label", "onClick"];
const _hoisted_7 = {
  class: "grid",
  role: "grid",
  "aria-label": "5×5 光路方格"
};
const _hoisted_8 = ["disabled", "aria-label", "onClick"];
const _hoisted_9 = {
  key: 0,
  class: "splitter-core"
};
const _hoisted_10 = {
  key: 1,
  class: "arrow-column arrow-column-right"
};
const _hoisted_11 = ["disabled", "aria-label", "onClick"];
const _hoisted_12 = {
  key: 1,
  class: "arrow-row arrow-row-bottom"
};
const _hoisted_13 = ["disabled", "aria-label", "onClick"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["optical-board", {
      compact: $props.compact
    }]),
    "aria-label": $props.ariaLabel
  }, [$props.showArrowSlots ? (_openBlock(), _createElementBlock("div", _hoisted_2, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, index => {
    return _createElementVNode("button", {
      key: `top-${index}`,
      type: "button",
      class: _normalizeClass(["arrow-slot", $options.arrowClasses('top', index - 1)]),
      disabled: !$props.editableArrows,
      "aria-label": $options.arrowAria('top', index - 1),
      onClick: $event => $options.updateArrow('top', index - 1)
    }, _toDisplayString($options.arrowGlyph('top', index - 1)), 11, _hoisted_3);
  }), 64))])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_4, [$props.showArrowSlots ? (_openBlock(), _createElementBlock("div", _hoisted_5, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, index => {
    return _createElementVNode("button", {
      key: `left-${index}`,
      type: "button",
      class: _normalizeClass(["arrow-slot", $options.arrowClasses('left', index - 1)]),
      disabled: !$props.editableArrows,
      "aria-label": $options.arrowAria('left', index - 1),
      onClick: $event => $options.updateArrow('left', index - 1)
    }, _toDisplayString($options.arrowGlyph('left', index - 1)), 11, _hoisted_6);
  }), 64))])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_7, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.board.cells, (cell, index) => {
    return _openBlock(), _createElementBlock("button", {
      key: index,
      type: "button",
      class: _normalizeClass(["grid-cell", {
        editable: $props.editableCells
      }]),
      disabled: !$props.editableCells,
      "aria-label": $options.cellAria(cell, index),
      onClick: $event => $options.updateCell(index)
    }, [$props.showElements && cell ? (_openBlock(), _createElementBlock("span", {
      key: 0,
      class: _normalizeClass(["optical-element", cell])
    }, [cell === 'splitter' ? (_openBlock(), _createElementBlock("span", _hoisted_9)) : _createCommentVNode("", true)], 2)) : _createCommentVNode("", true)], 10, _hoisted_8);
  }), 128))]), $props.showArrowSlots ? (_openBlock(), _createElementBlock("div", _hoisted_10, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, index => {
    return _createElementVNode("button", {
      key: `right-${index}`,
      type: "button",
      class: _normalizeClass(["arrow-slot", $options.arrowClasses('right', index - 1)]),
      disabled: !$props.editableArrows,
      "aria-label": $options.arrowAria('right', index - 1),
      onClick: $event => $options.updateArrow('right', index - 1)
    }, _toDisplayString($options.arrowGlyph('right', index - 1)), 11, _hoisted_11);
  }), 64))])) : _createCommentVNode("", true)]), $props.showArrowSlots ? (_openBlock(), _createElementBlock("div", _hoisted_12, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, index => {
    return _createElementVNode("button", {
      key: `bottom-${index}`,
      type: "button",
      class: _normalizeClass(["arrow-slot", $options.arrowClasses('bottom', index - 1)]),
      disabled: !$props.editableArrows,
      "aria-label": $options.arrowAria('bottom', index - 1),
      onClick: $event => $options.updateArrow('bottom', index - 1)
    }, _toDisplayString($options.arrowGlyph('bottom', index - 1)), 11, _hoisted_13);
  }), 64))])) : _createCommentVNode("", true)], 10, _hoisted_1);
}